export function authHeader(): string {
  // return authorization header with jwt token
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  if (user && user.token) {
    return "Bearer " + user.token;
  } else {
    return "";
  }
}



// WEBPACK FOOTER //
// ./src/helpers/auth-header.tsx